<template>
  <form
    class="input-group"
    :autocomplete="autocomplete ? 'on' : 'off'"
    @submit.prevent=""
  >
    <span class="icon">
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
          stroke="#8A8A8A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M16 16L13 13"
          stroke="#8A8A8A"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </span>
    <input
      type="text"
      class="form-control"
      placeholder="Поиск"
      v-model="searchString"
      @input="onUpdate"
      aria-label=""
      aria-describedby="basic-addon1"
    />

    <input
      type="button"
      class="search_button"
      value="Найти"
      v-if="active"
      @click="onSearch"
    />
    <span
      class="search_icon"
      v-else-if="searchString !== ''"
      @click="clearInput"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
          stroke="#C2C2D6"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M11.5 6.5L6.5 11.5"
          stroke="#C2C2D6"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M6.5 6.5L11.5 11.5"
          stroke="#C2C2D6"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>
    </span>
  </form>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    autoSearchButton: {
      default: true,
      type: Boolean,
    },
    autocomplete: {
      default: true,
      type: Boolean,
    },
  },
  model: {
    prop: 'value',
    event: 'update',
  },
  methods: {
    onUpdate(evnt) {
      const searchString = evnt.target.value
      this.active = this.autoSearchButton
        ? this.lastSearch !== searchString
        : false

      this.$emit('update', searchString)
    },
    onSearch() {
      this.lastSearch = this.searchString
      this.$emit('search', this.searchString)
      this.active = false
    },
    clearInput() {
      this.lastSearch = ''
      this.searchString = ''
      this.$emit('search', this.searchString)
    },
  },
  data() {
    return {
      lastSearch: '',
      searchString: '',
      active: false,
    }
  },
}
</script>

<style lang="scss">
.table-with-search {
  font-size: 0.75rem;
  font-weight: 700;
  min-height: 317px;
}

.table-with-search,
.screener {
  .input-group {
    background: rgba(#c2c2d6, 0.3);
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    height: 30px;
    display: flex;
    align-items: center;
    @include transition();
    @include transform(translateY(1px));

    &:hover {
      border-color: $primary-color2;
    }
    .icon svg {
      line-height: 14px;
      width: 14px;
      margin-left: 10px;
    }
    .search_button {
      background-color: $primary-color2;
      color: white;
      font-family: $primary-font;
      font-style: normal;
      font-weight: normal;
      font-size: 1rem;
      line-height: 1.5rem;
      padding-left: 10px;
      padding-right: 10px;
      border: 1px solid $primary-color2;
      border-radius: 4px;
      margin: 0;
    }

    .search_icon {
      background-color: transparent;
      font-family: $primary-font;
      font-style: normal;
      font-weight: normal;
      font-size: 1rem;
      line-height: 1.75rem;
      padding-left: 10px;
      padding-right: 10px;
      border: none;
      margin: 0;
      cursor: pointer;
      display: flex;
      align-items: center;

      svg path {
        stroke: #c2c2d6;
      }

      &:hover svg path {
        stroke: $primary-color2;
      }
    }

    .form-control {
      background-color: transparent;
      height: 26px;
      position: relative;
      border: 0;

      &:focus {
        outline: none;
        border: 0;
      }
    }
  }
}
</style>
